export enum ServicesFormEvent {
  ViewUpdate = 'ServicesFromViewUpdateEvent',
  MdrToggleUpdate = 'ServicesFormMdrToggleEvent',
}
